import { yupResolver } from '@hookform/resolvers/yup';
import LogoImg from 'assets/icons/logo.svg';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useFirebase } from 'v3/hooks/useFirebase';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { InputFormController } from 'v3/shared/components/Inputs/InputFormController';
import { InputFormPassword } from 'v3/shared/components/Inputs/InputFormPassword';
import { login } from 'v3/shared/schemas/login';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';
import { AligItems, Aside, Container, Header, LogoImgStyled } from './styles';
import { LoginType } from './types';

const ERROR_INCREMENT = 1;
export const LoginPage = () => {
  const { signIn, error } = useFirebase();
  const [errorCounter, setErrorCounter] = useState(0);

  const {
    control,
    getValues,
    setError,
    formState: { isValid },
  } = useForm<LoginType>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(login),
  });

  const onSubmit = async () => {
    const { user, password } = getValues();
    try {
      await signIn({ user: user.trim(), password });
    } catch {
      setErrorCounter((prev) => prev + ERROR_INCREMENT);
    }
  };

  useEffect(() => {
    if (error) {
      setError('password', { message: error });
    }
  }, [error, errorCounter]);

  return (
    <Container>
      <Header>
        <LogoImgStyled src={LogoImg} alt="Logo" />
      </Header>

      <Aside>
        <HeadlineSmall>Seja bem-vindo(a) ao Backoffice!</HeadlineSmall>
        <BodySmallRegular>Esta área é reservada apenas para colaboradores da Motorola.</BodySmallRegular>

        <AligItems>
          <InputFormController
            data-testid="input-email"
            inputType="email"
            formControl={control}
            formControlName="user"
            label="Usuário"
            placeholder="usuario@exemplo.com"
            fullWidth
          />
          <InputFormPassword
            data-testid="input-password"
            formControl={control}
            formControlName="password"
            label="Senha"
            fullWidth
          />
        </AligItems>
        <FlexButton data-testid="flex-button-login" text="Iniciar sessão" disabled={!isValid} handleClick={onSubmit} />
      </Aside>
    </Container>
  );
};
